import { Helmet } from "react-helmet-async";
import '../styles/equipamentos2.min.css';

import Img1 from '../assets/pilates-banner-equip-cadillac.png';
import Img2 from '../assets/banner-404-agrupado.png';
import Img3 from '../assets/pilates-equip-cadillac-img.png';

export default function Home() {

   return (
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/equipamentos/cadillac" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma." />
        </Helmet>
        
        <main>

            <section className="equipamentos-pilates">

                <div className="equip-cadillac-banner-box">

                    <div className="equip-pilates-banner-img">
                        <img className="hide--mobile" src={Img1}/>
                        <img className="hide--desk" src={Img2}/>
                    </div>

                    <div className="equip-pilates-title">
                        <h1> Equipamento <br/><span className="text-bold"> Cadillac</span> </h1>
                        <img className="cadillac-img" src={Img3}/>
                    </div>

                </div>

                <div className="pilates-cadillac-title">
                    <h2>
                        O Cadillac é uma das mais efetivas e<br/> versáteis peças do equipamento de<br/> exercícios que já foi
                        inventada
                    </h2>
                </div>

                <div className="pilates-cadillac-text">

                    <span>
                        O Cadillac é um equipamento de Pilates que lembra alguma coisa que você poderia encontrar em uma sala
                        medieval de tortura. Mas não se preocupe. O Cadillac é uma das mais efetivas e versáteis peças do
                        equipamento de exercícios que já foi inventada.<br/><br/>

                        Este equipamento foi originalmente desenvolvido por Joseh Pilates para reabilitar as costas de pacientes
                        acamados, quando ele estava trabalhando com um empregado do hospital. O aparelho evoluiu um pouco desde
                        então, mas sua inspiração e aparência continuam a ser uma ponte entre exercícios e fisioterapia.<br/><br/>

                        Mais de 80 diferentes exercícios podem ser realizados neste equipamento, variando de simples trabalho
                        sentado com as molas até acrobacias avançadas em que se pode ficar pendurado nas barras de cima. Portanto,
                        ele pode ser utilizado por todas as idades e habilidades. O repertório de exercícios desafia
                        verdadeiramente os músculos profundos do abdômen, desenvolve a flexibilidade da espinha, trabalha a
                        mobilidade do ombro, fortalece as costas e alonga o corpo todo.<br/><br/>

                    </span>

                </div>

            </section>

        </main>
    </>
  );
}